/* iter-qa-nav-pill · Floating "QA" pill for signed-in QA reviewers.
 *
 * Renders top-right on every page EXCEPT `/qa` itself when the current
 * session's role is `editor`. Gives the QA reviewer a one-click jump
 * back to their inbox from anywhere in the app (landing, admin panels,
 * editor pages, bookstore, wherever). Hidden for every other role.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '@/lib/auth_context';

export default function QANavPill() {
  const { user } = useAuth() || {};
  const loc = useLocation();
  if (!user || user.role !== 'editor') return null;
  if (loc.pathname.startsWith('/qa') || loc.pathname.startsWith('/quality')) return null;
  return (
    <Link
      to="/qa"
      data-testid="qa-nav-pill"
      className="fixed right-4 top-4 z-50 inline-flex items-center gap-1.5 rounded-full border border-stone-300 bg-stone-50 px-3 py-1.5 text-[11px] font-semibold text-stone-900 shadow-sm transition hover:bg-stone-100 hover:shadow"
      title="Open QA inbox"
    >
      <ShieldCheck className="h-3.5 w-3.5" />
      QA Inbox
    </Link>
  );
}
